module.exports = __webpack_public_path__ + "img/heart-inactive.71768a89.svg";